import xss from 'xss';
import { BLACKLISTED_ATTRIBUTES } from './constants';

/**
 * Sanitize a message body.
 * This will remove any blacklisted attributes from the message body.
 * This will also escape any HTML tags.
 * This will also remove any tags that are not whitelisted.
 *
 * @param {string} body - The message body.
 * @returns {string}
 */
export const sanitizeMessageBody = (body) => xss(body, {
    whiteList: xss.whiteList,
    escapeHtml,
    onIgnoreTagAttr
});

/**
 * Custom ignore tag attribute mechanism.
 * This is used to remove blacklisted attributes from tags.
 * If the attribute is blacklisted, it will not be added to the tag.
 * If the attribute is not blacklisted, it will be added to the tag.
 *
 * @param {string} tag - The tag name.
 * @param {string} name - The attribute name.
 * @param {string} value - The attribute value.
 * @returns {string | undefined}
 */
const onIgnoreTagAttr = (tag, name, value) => {
    if (BLACKLISTED_ATTRIBUTES.has(name)) {
        return;
    }

    return `${name}="${value}"`;
};

/**
 * Custom escape mechanism.
 *
 * @param {string} html - The HTML to escape.
 * @returns {string}
 */
const escapeHtml = (html) => html
    .replace(/<script>/g, '[script]')
    .replace(/<\/script>/g, '[/script]');
